module.exports = __webpack_public_path__ + "a1457b9e51496645e9aa65ba2eedfa0a.png";